import $ from 'jquery'
import fancybox from '../assets/FancyBox/jquery.fancybox.pack.js'
import fancyboxcss from '../assets/FancyBox/jquery.fancybox.css'

const imgMixin = {

    // data() {
    //     return {
    //
    //     }
    // },

    methods: {
        zoomIn(){
            let $img = $.fancybox.wrap.find('img.fancybox-image');
            let scale = $img.data('scale') || 1.0;
            scale += 0.2;
            $img.css('transform','scale('+(scale)+')');
            $img.data('scale', scale);
        },

        zoomOut(){
            let $img = $.fancybox.wrap.find('img.fancybox-image');
            let scale = $img.data('scale') || 1.0;
            scale -= 0.2;
            if(scale < 0.5){
                return false;
            }
            $img.css('transform','scale('+(scale)+')');
            $img.data('scale', scale);
        },

        imgmixin_lightzoomInit(){
            $('.lightzoom').fancybox({
                beforeShow: function () {
                    let downloadpath = $.fancybox.wrap.find('.fancybox-image').attr('src');
                        let $btn = $('<a href="' + downloadpath + '" class="btn" download>Скачать</a>');
                        let $div = $(`<div class="btns flex">
<button type="button" class="btn btn-primary margin-top-15 zoom-plus btn-img"><img src="/Content/dist/icon-plus-2.png" alt=""></button>
<button type="button" class="btn btn-primary margin-top-15 zoom-minus btn-img"><img src="/Content/dist/icon-minus-2.png" alt=""></button>
</div>`);
                        $.fancybox.wrap.find('.fancybox-outer').after($btn);
                        $.fancybox.wrap.find('.fancybox-outer').before($div);
                        $.fancybox.wrap.find('img.fancybox-image').draggable();

//                    let $div = $(`<div class="btns flex">
//<button type="button" class="btn btn-primary zoom-plus"><img src="/Content/dist/icon-plus-2.png" alt="" class="btn-img"></button>
//<button type="button" class="btn btn-primary zoom-minus"><img src="/Content/dist/icon-minus-2.png" alt="" class="btn-img"></button>
//</div>`);
//                    $.fancybox.wrap.find('.fancybox-outer').before($div);
//                    $.fancybox.wrap.find('img.fancybox-image').draggable();
                },
                afterClose: function () {
                    $('.lightzoom').css({ "display": "block" });
                }
            });
        }
    },

    mounted() {
        let vm = this;

        vm.imgmixin_lightzoomInit();

        $(document).on('click', '.zoom-plus', function(){
            vm.zoomIn();

        });
        $(document).on('click', '.zoom-minus', function(){
            vm.zoomOut();
        });

        $(window).bind('mousewheel DOMMouseScroll', function(event){
            if($.fancybox.wrap != null){
                if (event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0) {
                    vm.zoomOut();
                }
                else {
                    vm.zoomIn();
                }
            }
        });
    },

    destroyed(){
        $(window).unbind('mousewheel DOMMouseScroll');
        $(document).off('click', '.zoom-plus');
        $(document).off('click', '.zoom-minus');
    }
};

export default imgMixin;


// WEBPACK FOOTER //
// ./Content/src/helpers/img-mixin.js